import React from 'react';
import PropTypes from 'prop-types';

import Card from 'components/base/Card';
import CardBody from 'components/base/CardBody';
import Title from 'components/base/Title';

import RenderToRoot from 'utils/RenderToRoot';

const ErrorPage = ({ title, error, requestId, details }) => {
  return (
    <Card className="mt-4">
      <CardBody>
        <Title>{title}</Title>
        {details && <p className="centered pt-3">{details}</p>}
        {(error || requestId) && (
          <Card>
            {error && (
              <p>
                {' '}
                <code>{error}</code>
              </p>
            )}
            {requestId && (
              <p>
                Request ID: <code>{requestId}</code>
              </p>
            )}
          </Card>
        )}
      </CardBody>
    </Card>
  );
};

ErrorPage.propTypes = {
  title: PropTypes.string.isRequired,
  requestId: PropTypes.string,
  error: PropTypes.string,
  details: PropTypes.string,
};

ErrorPage.defaultProps = {
  requestId: null,
  error: null,
  details: null,
};

export default RenderToRoot(ErrorPage);
